import * as React from 'react';
import { useParams } from 'react-router-dom';
import { PublicChatView } from '../components/PublicChatView';
import type { Echo } from '@/types';
import echoCreatedImage from '@/assets/images/webp/echo_created.webp';

export const CustomPublicChatPage: React.FC = () => {
  const { pageSlug = '' } = useParams<{ pageSlug: string }>();

  const placeholderEcho: Echo = {
    id: '',
    name: 'Echo',
    category: 'Public Figure',
    domain: 'General',
    imageUrl: echoCreatedImage,
  };

  return (
    <div className='h-dvh w-full overflow-hidden bg-black'>
      <PublicChatView echo={placeholderEcho} echoName='Echo' pageSlug={pageSlug} />
    </div>
  );
};

export default CustomPublicChatPage;
